import clsx from 'clsx';
import React from 'react';

import Input, { InputProps } from './Input';

type TextFieldProps = InputProps & {
  name: string;
};

const TextField = ({ className, inputClassName, label, maxCharCount, ...rest }: TextFieldProps) => {
  return (
    <Input
      type="text"
      className={className}
      inputClassName={clsx(
        inputClassName,
        'h-[50px] w-full rounded-none border border-solid border-grayscale-beige px-8 py-16 font-suisse-intl text-overline-md text-black placeholder-grayscale-gray focus:outline-none disabled:opacity-40 disabled:bg-white disabled:text-grayscale-gray'
      )}
      label={label}
      maxCharCount={maxCharCount}
      {...rest}
    />
  );
};

export default TextField;
